module.exports = {"150524100":"库伦镇","150524101":"扣河子镇","150524102":"白音花镇","150524103":"六家子镇","150524104":"额勒顺镇","150524200":"茫汗苏木","150524201":"先进苏木","150524202":"水泉乡","150524400":"库伦街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150524.json
// module id = 386
// module chunks = 0